module.exports = __webpack_public_path__ + "img/maitrise_1122x540.4b59fba5.png";